import * as React from 'react';
import axios from 'axios';

// @ts-ignore
import * as Scroll from 'react-scroll';
import { renderFilArianne, renderTitleH1 } from './RenderCommon';
import { getUserId, sessionExpire } from './MonCompteAction';
import { MotifAnnulation, Order, PaymentMethod } from './iMonCompte';
import { getHostApi, getRequestConfig,  initEvent } from '../../utils';
import RenderOrderLine from './RenderOrderLine';
import RenderSplitOrderLine from './RenderSplitOrderLine';

//eslint-disable-next-line
declare var moment: any;

interface RenderOrdersState {
  orders: Order[];
  paymentMethods: PaymentMethod[];
  ordersOldExist: boolean;
  activateAnnulation: boolean;
  activateAnnulationAutreMoyenPaiement: number;
  motifsAnnulation: MotifAnnulation[];
}

export default class RenderOrders extends React.Component<unknown, RenderOrdersState> {
  constructor(props: unknown) {
    super(props);
    this.state = {
      orders: [],
      paymentMethods: [],
      ordersOldExist: false,
      activateAnnulation: false,
      activateAnnulationAutreMoyenPaiement: 0,
      motifsAnnulation: [],
    };
  }

  componentDidMount() {
    this._getAllOrdersByCustomer();
    this._getAllPaymentMethods();
    this._getMotifsAnnulation();
    this._getActivationAnnulation();
    this._getActivationAnnulationAutreMoyenPaiement();
  }

  _getMotifsAnnulation = () => {
    axios.get(`${getHostApi()}/shops/annulation-motifs`, getRequestConfig())
      .then((response) => {
      if (response.data.motifsAnnulation) {
        this.setState({ motifsAnnulation: response.data.motifsAnnulation });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  /**
   * Fonction retournant toutes les commandes de l'utilisateur conecté
   *
   * @returns {Order[]}
   * @private
   */
  _getAllOrdersByCustomer() {
    document.dispatchEvent(initEvent('dp-loading'));

    axios.get(`${getHostApi()}/customers/${getUserId()}/orders/`, getRequestConfig())
      .then((response) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (response.data.orders) {
        this.setState({ orders: response.data.orders }, () => {
          this._displayOldOrders();
        });
      }
    }).catch((error) => {
      document.dispatchEvent(initEvent('dp-loaded'));
      if (error.response && error.response.status && error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  /**
   * Fonction permettant de retourner la variable d'activation de l'annulation d'une commande en cours
   *
   * @private
   */
  _getActivationAnnulation() {
    axios.get(`${getHostApi()}/shops/features/compte_annulation_client`, getRequestConfig())
      .then((response) => {
      if (response.data.feature) {
        this.setState({ activateAnnulation: response.data.feature });
      }
    }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }

  /**
   * Fonction permettant de retourner la variable d'activation de l'annulation d'une commande en cours pour les moyens de paiement: chèque, virement ou bon de commande administratif
   *
   * @private
   */
  _getActivationAnnulationAutreMoyenPaiement() {
    axios.get(`${getHostApi()}/shops/features/compte_annulation_client_autre_moyen_paiement`, getRequestConfig())
        .then((response) => {
          if (response.data.feature) {
            this.setState({ activateAnnulationAutreMoyenPaiement: response.data.feature });
          }
        }).catch((error) => {
      if (error.response.status === 401) {
        sessionExpire();
      }
    });
  }
  /**
   * TODO: modifier l'appel à la route => nécessite l'idCaddie
   *
   * Fonction permettant de retourner tous les moyens de paiement disponibles
   *
   * @private
   */
  _getAllPaymentMethods() {
    //voir la recuperation idLang quand traduction Mon compte
    axios.get(`${getHostApi()}/carts/0/payment-methods/country/0/lang/1`, getRequestConfig())
      .then((response) => {
      if (response.data.payment_methods) {
        this.setState({
          paymentMethods: response.data.payment_methods,
        });
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  _showAllOrders = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    const oldOrdersHide = document.querySelectorAll('.row-order.old-order');
    const oldOrders = document.querySelectorAll('.row-order.opacTransition');
    if (oldOrders.length === 0) {
      for (const oldOrder of oldOrdersHide) {
        oldOrder.classList.add('opacTransition', 'pa2');
        oldOrder.classList.remove('pa0');
      }
    } else {

      const scroll = Scroll.animateScroll;
      const Events = Scroll.Events;
      scroll.scrollToTop();
      // Events.scrollEvent.register('end', function (to, element) {
      Events.scrollEvent.register('end', () => {
        for (const oldOrder of oldOrders) {
          oldOrder.classList.remove('opacTransition', 'pa2');
          oldOrder.classList.add('pa0');
        }
      });
    }
  }

  /*
    Affiche les vieilles commandes uniquement si celles-ci sont toutes masquées
   */
  _displayOldOrders() {
    const allOrders = document.querySelectorAll('.row-order');
    const oldOrdersHide = document.querySelectorAll('.row-order.old-order');
    const oldOrders = document.querySelectorAll('.row-order.opacTransition');

    if (oldOrders.length === 0 && allOrders[0] && allOrders[0].classList.contains('old-order')) {
      for (const oldOrder of oldOrdersHide) {
        oldOrder.classList.add('opacTransition', 'pa2');
        oldOrder.classList.remove('pa0');
      }
    }
  }

  getListOrders() {
    let oldOrderExist = false;
    const elementMapped = this.state.orders.filter(order => order.parent_id == null).map((order: Order) => {
      if(order.is_splitted) {
        const children = this.state.orders.filter(elt => elt.parent_id == parseInt(order.idCommande));

        return (<RenderSplitOrderLine order={order} children={children} activateAnnulation={this.state.activateAnnulation} activateNewUpload motifsAnnulation={this.state.motifsAnnulation} />)
      }

      const dateCommande = moment(order.DateDeCommande, 'YYYY-MM-Do h:mm:ss').toDate();
      const dateJour = moment().toDate();
      const diff = moment(dateJour).diff(moment(dateCommande), 'days');
      // Afficher seulement les commandes passées il y a moins de 365 jours
      const isOldOrder = !(diff <= 365 || (order.StatutCommande >= '2' && order.StatutCommande <= '7'));
      oldOrderExist = (!oldOrderExist) ? isOldOrder : oldOrderExist;

      return (
        <RenderOrderLine key={order.idCommande} order={order} paymentMethods={this.state.paymentMethods}
                        activateAnnulation={this.state.activateAnnulation}
                        activateNewUpload oldOrder={isOldOrder}
                        motifsAnnulation={this.state.motifsAnnulation} />
      );
    });

    if (!this.state.ordersOldExist && oldOrderExist !== this.state.ordersOldExist) {
      this.setState({ ordersOldExist: oldOrderExist });
    }
    return elementMapped;
  }

  render() {
    const renderListOrders = this.getListOrders();

    return (
      <div>
        {renderTitleH1('colis', 'Mes commandes')}
        {renderFilArianne('', 'Mes commandes')}
        {renderListOrders.length === 0 && (
          <div className="mt-4">
            <p className="text-center font16 bold">Aucune commande en cours.</p>
          </div>
        )}
        {renderListOrders}
        {(this.state.ordersOldExist && renderListOrders[0] && renderListOrders[0].props.oldOrder == false) && (
          <div className="text-center mt5 grey">
            <button id="showHideBtn" onClick={event => this._showAllOrders(event)}
                    className="cursor-pointer myButton border grey font14 mt-3 mb-3 py-3 pl-5 pr-5">
              Afficher / Masquer toutes mes anciennes commandes
            </button>
          </div>
        )}
        <div className="text-center mt5 grey">
          <p className="mt-3 text-center">
            Les commandes non r&eacute;glées dans les 30 jours passeront automatiquement dans le statut
            "COMMANDE ANNUL&Eacute;E". </p>
        </div>
      </div>
    );
  }
}
